import { render, staticRenderFns } from "./OneCourse.vue?vue&type=template&id=9aad3e20&"
import script from "./OneCourse.vue?vue&type=script&lang=js&"
export * from "./OneCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports